import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { formatDate } from "../../lib/utils";
import SettingsSection from "./SettingsSection";

export default function SubscriptionPanel() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/company/subscription").then((r) => setS(r.data)).catch(() => {}); }, []);

  const body = () => {
    if (!s) return <div className="surface-card p-4 text-sm text-slate-400">Loading…</div>;
    if (!s.plan) return <div className="surface-card p-4 text-sm text-slate-500">No plan assigned — contact your platform administrator.</div>;
    const due = s.plan_renewal_at ? (new Date(s.plan_renewal_at).getTime() - Date.now()) : null;
    const soon = due !== null && due < 7 * 864e5;
    const lim = (v) => (v === null || v === undefined ? "∞" : v);
    return (
      <div className="surface-card p-5 space-y-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.15em] text-slate-400 font-semibold">Current plan</div>
          <div className="text-2xl font-bold text-slate-900 tracking-tight">{s.plan.name} <span className="text-sm font-normal text-slate-500">/ {s.plan.billing_cycle}</span></div>
        </div>
        <div className="grid grid-cols-2 gap-3 text-sm">
          <div><div className="text-slate-400 text-xs">Active since</div><div className="text-slate-800">{s.plan_started_at ? formatDate(s.plan_started_at) : "—"}</div></div>
          <div><div className="text-slate-400 text-xs">Renews on</div><div className={soon ? "text-rose-600 font-medium" : "text-slate-800"}>{s.plan_renewal_at ? formatDate(s.plan_renewal_at) : "—"}</div></div>
        </div>
        {s.usage && <div className="text-xs text-slate-500 border-t border-slate-100 pt-3">Users {s.usage.users}/{lim(s.plan.max_users)} · Projects {s.usage.projects}/{lim(s.plan.max_projects)} · Clients {s.usage.clients}/{lim(s.plan.max_clients)}</div>}
      </div>
    );
  };

  return (
    <SettingsSection title="Subscription" description="Your current plan and usage.">
      {body()}
    </SettingsSection>
  );
}
